import { memo } from 'react';
import dynamic from 'next/dynamic';
import cn from 'classnames';
import { Container, Element, Icon, RouterLink } from 'src/components';
import Level from 'src/components/grid/level';
import Nossr from 'src/components/nossr';
import { IFooter } from 'src/interface';
import { ArrayUtils } from 'src/utils';

const LINK_DOWNLOAD_APP = 'https://baomoi.onelink.me/Dfp0/1e035efe';

const SlideFooter = dynamic(() => import('./slide'), {
    ssr: false,
});

function Footer({ footer }: { footer: IFooter }) {
    let { tags = [], customTags = [] } = footer || {};
    const _tags = [...tags, ...customTags];

    return (
        <Element renderAs="footer" className={cn('bm-footer', 'mt-[32px]')}>
            <RouterLink
                to={LINK_DOWNLOAD_APP}
                className={cn(
                    'link-download',
                    'relative block',
                    'py-[12px]',
                    'bg-[#f8f9fa]',
                    'border-t border-solid border-[#F0F0F0]',
                )}
            >
                <Container>
                    <Level>
                        <Level.Item className="!mr-[12px]">
                            <Icon type="bm" icon="baomoi-app" />
                        </Level.Item>
                        <Level.Item
                            className={cn(
                                'app-text',
                                'font-semibold',
                                'flex-col items-start',
                                'shrink'
                            )}
                        >
                            <Element
                                className={cn(
                                    'text-[16px]',
                                    'pt-[8px]',
                                    'uppercase',
                                )}
                                renderAs="span"
                            >
                                Tải ứng dụng báo mới
                            </Element>
                            <Element
                                className={cn(
                                    'text-[12px] text-[#4D4D4D]',
                                    'pt-[4px]',
                                    'uppercase',
                                )}
                                renderAs="span"
                            >
                                Để không bỏ sót tin tức
                            </Element>
                        </Level.Item>
                        <Level.Item>
                            <Icon
                                className={cn(
                                    'w-[50px] h-[50px]',
                                    'text-[32px] text-[#2FA1B3B2]',
                                    'flex items-center justify-center',
                                    'rounded-full',
                                    'bg-[#DAF1F680]',
                                )}
                                icon="new-cloud-arrow-solid"
                            />
                        </Level.Item>
                    </Level>
                </Container>
            </RouterLink>
            <Element
                className={cn(
                    'flex',
                    'px-[16px]',
                    'border-t border-b border-solid border-[#e9ecef]',
                    'font-semibold',
                )}
            >
                <RouterLink
                    className={cn(
                        'flex items-center justify-center',
                        'w-1/2',
                        'py-[13px]',
                        'text-[13px] text-[#1A1A1A]',
                    )}
                    to="/staticpages/termsofuse.epi"
                    newTab
                >
                    <Icon
                        className={cn('text-[26px] text-[#4D4D4D]', 'mr-[6px]')}
                        icon="new-hands-shake-regular"
                    />
                    Điều khoản sử dụng
                </RouterLink>
                <RouterLink
                    className={cn(
                        'flex items-center justify-center',
                        'w-1/2',
                        'py-[13px]',
                        'text-[#1A1A1A]',
                    )}
                    to="/staticpages/privacy.epi"
                    newTab
                >
                    <Icon
                        className={cn('text-[26px] text-[#4D4D4D]', 'mr-[6px]')}
                        icon="new-document-security-regular"
                    />
                    Chính sách bảo mật
                </RouterLink>
            </Element>
            {!ArrayUtils.isEmpty(_tags) && (
                <>
                    <Container>
                        <Element
                            className={cn(
                                'text-center',
                                'mt-[15px] mx-0 pb-[10px]',
                                'border-b-[#eee] border-b border-solid',
                            )}
                        >
                            {_tags?.map((item: any, index: number) => {
                                return (
                                    <span
                                        className={cn(
                                            'inline-block text-[1.3rem] text-[#6c757d] capitalize',
                                            "before:content-['•']  before:inline-block",
                                            'before:text-[0.8rem] before:leading-[18px] before:text-[#ccc]',
                                            'before:px-[6px] before:py-0',
                                        )}
                                        key={index}
                                    >
                                        <RouterLink
                                            to={item.url}
                                            title={item.name}
                                        >
                                            {item.name}{' '}
                                        </RouterLink>
                                    </span>
                                );
                            })}
                        </Element>
                    </Container>
                </>
            )}
            <Container>
                <Element
                    className={cn(
                        'copyright-wrapper',
                        'text-[12px] leading-[1.4] text-center text-[#666]',
                        'pt-[24px] pb-[24px]',
                    )}
                >
                    <Nossr>
                        <p className="flex flex-col gap-[11px]">
                            <span>
                                Giấy phép thiết lập trang thông tin điện tử
                            </span>
                            <span>
                                tổng hợp số 1818/GP-TTĐT do Sở Thông tin và
                                Truyền thông Hà Nội cấp ngày 05/05/2017
                            </span>
                            <span>
                                Đơn vị thiết lập: Công ty cổ phần công nghệ EPI
                            </span>
                            <span>
                                Chịu trách nhiệm quản lý nội dung: Vũ Trọng
                                Cường
                            </span>
                            <span>
                                Địa chỉ: Tầng 16, Tòa nhà ROX Tower, số 54A
                                Nguyễn Chí Thanh, Phường Láng, Thành phố Hà Nội
                            </span>
                            <span>Tel: (024) 3-542-3555</span>
                            <span>Email: contact.baomoi@epi.com.vn</span>
                            <span>
                                BAOMOI tổng hợp và sắp xếp các thông tin tự động
                                bởi chương trình máy tính
                            </span>
                        </p>
                    </Nossr>
                </Element>
            </Container>
            <SlideFooter />
        </Element>
    );
}

export default memo(Footer);
